import { useState } from 'react';

function ProductTabs({ selectedProduct, selectedGout, selectedPoids }) {
  const [activeTab, setActiveTab] = useState("info");

  // Get details from variation OR from product directly
  const details = selectedProduct?.variations?.[selectedGout]?.details?.[selectedPoids] || {
    composition: selectedProduct?.composition,
    analysis: selectedProduct?.analysis,
    ingredients: selectedProduct?.ingredients,
    antioxidants: selectedProduct?.antioxidants,
    energy: selectedProduct?.energy,
  };

  return (
    <div className="product-tabs mt-5" style={{ fontFamily: 'Arial, sans-serif' }}>
      {/* Tabs Header */}
      <div
        className="tabs-header"
        style={{
          display: 'flex',
          gap: '10px',
          borderBottom: '2px solid #eee',
        }}
      >
        <button
          className={activeTab === "info" ? "active" : ""}
          onClick={() => setActiveTab("info")}
          style={{
            padding: '10px 20px',
            border: 'none',
            borderBottom: activeTab === "info" ? '3px solid #c71585' : '3px solid transparent',
            backgroundColor: 'transparent',
            color: activeTab === "info" ? '#c71585' : '#555',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
          }}
        >
          Informations complémentaires
        </button>
        <button
          className={activeTab === "avis" ? "active" : ""}
          onClick={() => setActiveTab("avis")}
          style={{
            padding: '10px 20px',
            border: 'none',
            borderBottom: activeTab === "avis" ? '3px solid #c71585' : '3px solid transparent',
            backgroundColor: 'transparent',
            color: activeTab === "avis" ? '#c71585' : '#555',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
          }}
        >
          Avis (0)
        </button>
      </div>

      {/* Tabs Body */}
      <div className="tabs-body mt-4">
        {activeTab === "info" && (
          <div className="tab-content info-tab">
            <table
              className="product-info-table"
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '20px',
              }}
            >
              <tbody>
                {details.composition && (
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <th style={{ textAlign: 'left', padding: '12px', width: '200px', color: '#555', fontWeight: 600 }}>
                      Composition
                    </th>
                    <td style={{ padding: '12px', color: '#333', lineHeight: '1.6' }}>
                      {details.composition}
                    </td>
                  </tr>
                )}
                {details.analysis && (
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <th style={{ textAlign: 'left', padding: '12px', color: '#555', fontWeight: 600 }}>
                      Analyse
                    </th>
                    <td style={{ padding: '12px', color: '#333', lineHeight: '1.6' }}>
                      {details.analysis}
                    </td>
                  </tr>
                )}
                {details.ingredients && (
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <th style={{ textAlign: 'left', padding: '12px', color: '#555', fontWeight: 600 }}>
                      Ingrédients
                    </th>
                    <td style={{ padding: '12px', color: '#333', lineHeight: '1.6' }}>
                      {details.ingredients}
                    </td>
                  </tr>
                )}
                {details.antioxidants && (
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <th style={{ textAlign: 'left', padding: '12px', color: '#555', fontWeight: 600 }}>
                      Antioxydants
                    </th>
                    <td style={{ padding: '12px', color: '#333', lineHeight: '1.6' }}>
                      {details.antioxidants}
                    </td>
                  </tr>
                )}
                {details.energy && (
                  <tr style={{ borderBottom: '1px solid #eee' }}>
                    <th style={{ textAlign: 'left', padding: '12px', color: '#555', fontWeight: 600 }}>
                      Énergie métabolisable
                    </th>
                    <td style={{ padding: '12px', color: '#333', lineHeight: '1.6' }}>
                      {details.energy}
                    </td>
                  </tr>
                )}

                {/* Show message if no nutritional info available */}
                {!details.composition && !details.analysis && !details.ingredients &&
                  !details.antioxidants && !details.energy && (
                    <tr>
                      <td colSpan="2" style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                        Aucune information nutritionnelle disponible pour ce produit.
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === "avis" && (
          <div className="tab-content avis-tab" style={{ marginTop: '15px' }}>
            <p><strong>Avis</strong></p>
            <p>Il n'y a pas encore d'avis.</p>
            <p>Soyez le premier à laisser votre avis sur "{selectedProduct.name}"</p>

            <form className="review-form" style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px' }}>
              <label style={{ fontWeight: 600 }}>Votre note :</label>
              <div className="stars" style={{ color: '#f5c518', fontSize: '20px' }}>★★★★★</div>

              <label style={{ fontWeight: 600 }}>Votre avis :</label>
              <textarea
                rows="4"
                placeholder="Écrivez votre avis ici..."
                style={{
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '14px',
                  resize: 'vertical'
                }}
              ></textarea>

              <div style={{ display: 'flex', gap: '10px' }}>
                <div style={{ flex: 1 }}>
                  <label>Nom *</label>
                  <input
                    type="text"
                    style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label>E-mail *</label>
                  <input
                    type="email"
                    style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }}
                  />
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <input type="checkbox" />
                <label style={{ fontSize: '13px', color: '#555' }}>
                  Enregistrer mon nom, mon e-mail et mon site dans le navigateur pour mon prochain commentaire.
                </label>
              </div>

              <button
                type="submit"
                style={{
                  backgroundColor: '#c71585',
                  color: '#fff',
                  padding: '10px 15px',
                  borderRadius: '6px',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 600,
                  marginTop: '10px',
                  transition: 'background 0.3s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#a30f68'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#c71585'}
              >
                Soumettre
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductTabs;
